//主推keep me poster
 document.addEventListener('DOMContentLoaded', function() {
      try {
        // 多选择器兜底：ID + class，避免ID冲突
        const btn = document.getElementById('customSuccessBtn-{{ section.id }}') || document.querySelector('.custom-success-trigger');
        
        if (btn) {
          // 从data属性获取原始文字（更可靠）
          const originalText = btn.dataset.originalText || btn.textContent;
          const originalClass = btn.className;

          // 绑定点击事件（移除原有事件，避免重复绑定）
          btn.removeEventListener('click', handleBtnClick);
          btn.addEventListener('click', handleBtnClick);

          function handleBtnClick() {
          // 核心修改：先禁用按钮，0.3秒后再切换样式
            btn.disabled = true; // 点击后立即禁用，防止重复点击
            setTimeout(() => {
              btn.textContent = 'Success !!';
              btn.className = 'custom-action-btn custom-action-btn--success';
            }, 300); 

            // 2秒后恢复原始状态（从点击开始计时，总共2秒）
            setTimeout(() => {
              btn.textContent = originalText;
              btn.className = originalClass;
              btn.disabled = false;
            }, 2000); // 2000毫秒 = 2秒
          }
        } else {
        }
      } catch (e) {
      }
    });
// 
// 
// //banner滑动
function scrollToCalendar() {
  const targetElement = document.getElementById('Handpick');
  if (targetElement) {
    targetElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}
// 等待页面DOM加载完成
document.addEventListener('DOMContentLoaded', function() {

  // 隐藏无货产品卡片核心函数
function hideOutOfStockProducts() {
  // 遍历所有产品卡片（匹配你的卡片类名 .tab-product-card）
  document.querySelectorAll('.tab-product-card').forEach(card => {
    // 检查卡片内是否sold out（你的按钮类名：.custom-sold-out-btn）
    const addToCartBtn = card.querySelector('.custom-sold-out-btn');
    // 同时兼容Liquid添加的out-of-stock类（双重保险）
    const isSoldOut = addToCartBtn || card.classList.contains('out-of-stock');
    
    // 如果无货，隐藏整个卡片；有货则显示
    if (isSoldOut) {
      card.style.display = 'none';
    } else {
      card.style.display = 'block'; 
    }
  });
}

// 页面加载完成后执行（首次加载隐藏无货卡片）
document.addEventListener('DOMContentLoaded', function() {
  hideOutOfStockProducts();
  
  // 兼容Tab切换场景：切换Tab后重新检查无货卡片
  document.querySelectorAll('.tab-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      // 延迟执行，确保Tab内容加载完成
      setTimeout(hideOutOfStockProducts, 100);
    });
  });
});

// 兼容产品变体切换（如果有变体选择功能，可选）
document.addEventListener('change', function(e) {
  if (e.target.name === 'id') {
    setTimeout(hideOutOfStockProducts, 100);
  }
});

  // 初始加载时执行一次
  hideOutOfStockProducts();

  // Tab切换逻辑（如果原有Tab切换无JS，需补充）
  const tabButtons = document.querySelectorAll('.valentine-tab-only .tab-btn');
  const tabPanes = document.querySelectorAll('.valentine-tab-only .tab-pane');

  tabButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      // 移除所有Tab激活状态
      tabButtons.forEach(b => b.classList.remove('active'));
      tabPanes.forEach(p => p.classList.remove('active'));
      
      // 激活当前Tab
      this.classList.add('active');
      const targetTab = document.getElementById(this.dataset.tab);
      targetTab.classList.add('active');

    });
  });

  // 兼容滚动/动态加载场景：监听卡片容器变化（可选）
  const observer = new MutationObserver(hideOutOfStockProducts);
  document.querySelectorAll('.cards-container').forEach(container => {
    observer.observe(container, { childList: true, subtree: true });
  });
});




//box2 导航栏
document.addEventListener('DOMContentLoaded', function() {
    // ========== 1. 原有导航跳转/高亮逻辑（完全保留） ==========
    // 获取导航元素和目标元素
    const navItems = document.querySelectorAll('.box2_nav div');
    const sections = {
        'Find Your Gift': document.getElementById('giftFinderContainer'),
        'Top picks': document.getElementById('Handpick'),
        'Shop by Moment': document.getElementById('Classify')
    };

    // 导航点击事件
    navItems.forEach(item => {
        item.addEventListener('click', function() {
            const text = this.textContent.trim();
            scrollToSection(text);
        });
    });

    // 滚动到指定区域
    function scrollToSection(sectionName) {
        const targetElement = sections[sectionName];
        
        if (targetElement) {
            // 更新导航激活状态
            navItems.forEach(nav => nav.classList.remove('navActive'));
            const activeNav = Array.from(navItems).find(nav => nav.textContent.trim() === sectionName);
            if (activeNav) activeNav.classList.add('navActive');

            // 滚动到目标位置（考虑50px偏移）
            const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - 48;
            
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    }

    // 滚动监听函数（更新激活导航）
    function updateActiveNavOnScroll() {
        const scrollPosition = window.pageYOffset + 100; // 提前100px触发切换
        
        // 找到当前可见的区域
        let currentSection = null;
        const sectionEntries = Object.entries(sections);
        for (let i = sectionEntries.length - 1; i >= 0; i--) {
            const [name, element] = sectionEntries[i];
            if (element && element.offsetTop <= scrollPosition) {
                currentSection = name;
                break;
            }
        }
        
        // 更新导航激活状态
        if (currentSection) {
            navItems.forEach(nav => nav.classList.remove('navActive'));
            const activeNav = Array.from(navItems).find(nav => nav.textContent.trim() === currentSection);
            if (activeNav) activeNav.classList.add('navActive');
        }
    }

    // ========== 2. 新增：导航栏固定逻辑（核心修复） ==========
    const nav = document.querySelector('.box2_nav');
    if (nav) {
        // 获取导航栏初始位置（距离顶部的距离）
        let navTop = nav.getBoundingClientRect().top + window.scrollY;
        
        // 固定导航栏的函数
        function fixNavOnScroll() {
            // 滚动到导航栏位置时，添加fixed类；否则移除
            if (window.scrollY >= navTop) {
                nav.classList.add('fixed');
            } else {
                nav.classList.remove('fixed');
            }
        }

        // 窗口大小变化时，重新计算导航栏初始位置（适配响应式）
        function resetNavPosition() {
            navTop = nav.getBoundingClientRect().top + window.scrollY;
            fixNavOnScroll(); // 重新检查固定状态
        }

        // 初始化执行一次
        fixNavOnScroll();

        // 监听窗口大小变化
        window.addEventListener('resize', resetNavPosition);
    }

    // ========== 3. 合并滚动监听（节流优化，避免重复监听） ==========
    let scrollTimeout;
    function throttleScroll() {
        if (!scrollTimeout) {
            scrollTimeout = setTimeout(function() {
                scrollTimeout = null;
                updateActiveNavOnScroll(); // 原有：更新激活导航
                if (nav) fixNavOnScroll(); // 新增：更新固定状态
            }, 100); // 保留原有100ms节流，不影响性能
        }
    }

    // 只保留一个滚动监听（合并两个逻辑）
    window.addEventListener('scroll', throttleScroll);
    
    // 初始化时检查一次
    updateActiveNavOnScroll();
});
// // copy
// function copyText(el, text, event) {
//     event.stopPropagation(); // 阻止事件冒泡（避免触发父元素的点击事件）
//     navigator.clipboard.writeText(text).then(() => {
//         const originalText = el.textContent;  // 保存原始文本（比如"copy"）
//         el.textContent = 'copied';            // 复制成功后，按钮文字改为"copied"
//         setTimeout(() => {
//             el.textContent = originalText;    // 3秒后恢复原始文字
//         }, 3000);
//     })
// }

// box6 切换功能
document.querySelectorAll('.tab-btn').forEach(button => {
  button.addEventListener('click', () => {
    document.querySelectorAll('.tab-btn').forEach(btn => btn.classList.remove('active'));
    button.classList.add('active');
    
    document.querySelectorAll('.tab-pane').forEach(pane => pane.classList.remove('active'));
    document.getElementById(button.getAttribute('data-tab')).classList.add('active');
  });
});


document.addEventListener('DOMContentLoaded', function() {
  // 获取所有卡片容器和按钮
  const cardsContainers = document.querySelectorAll('.cards-container');
  const leftButtons = document.querySelectorAll('.scroll-left');
  const rightButtons = document.querySelectorAll('.scroll-right');
  
  // 为每个容器添加滚动功能
  cardsContainers.forEach((container, index) => {
    const leftBtn = leftButtons[index];
    const rightBtn = rightButtons[index];
    
    if (leftBtn && rightBtn) {
      // 向左滚动
      leftBtn.addEventListener('click', () => {
        const cardWidth = container.querySelector('.card-mold').offsetWidth + 16; // 卡片宽度 + gap
        const scrollDistance = cardWidth * 1; // 滚动2张卡片的距离
        container.scrollBy({
          left: -scrollDistance,
          behavior: 'smooth'
        });
      });
      
      // 向右滚动
      rightBtn.addEventListener('click', () => {
        const cardWidth = container.querySelector('.card-mold').offsetWidth + 16; // 卡片宽度 + gap
        const scrollDistance = cardWidth * 1; // 滚动2张卡片的距离
        container.scrollBy({
          left: scrollDistance,
          behavior: 'smooth'
        });
      });
      
      // 根据滚动位置显示/隐藏按钮
      const updateButtonVisibility = () => {
        const scrollLeft = container.scrollLeft;
        const scrollWidth = container.scrollWidth;
        const clientWidth = container.clientWidth;
        
        // 隐藏左按钮当滚动到最左边
        leftBtn.style.opacity = scrollLeft <= 0 ? '0.5' : '1';
        leftBtn.style.cursor = scrollLeft <= 0 ? 'not-allowed' : 'pointer';
        
        // 隐藏右按钮当滚动到最右边
        rightBtn.style.opacity = scrollLeft + clientWidth >= scrollWidth - 1 ? '0.5' : '1';
        rightBtn.style.cursor = scrollLeft + clientWidth >= scrollWidth - 1 ? 'not-allowed' : 'pointer';
      };
      
      // 监听滚动事件
      container.addEventListener('scroll', updateButtonVisibility);
      
      // 初始更新按钮状态
      updateButtonVisibility();
    }
  });
});

 document.addEventListener('DOMContentLoaded', function() {
// 覆盖图片功能
function initCoverImages() {
  // 1. 仅移动端执行
  if (window.innerWidth > 768) return;

  // 2. 获取所有cover容器（替代原来的cover-image）
  const coverContainers = document.querySelectorAll('.box4 .cover-container');
  
  if (coverContainers.length === 0) return;

  // 3. 遍历所有容器，按需求初始化并设置切换逻辑
  coverContainers.forEach((container, index) => {
    let isVisible; // 控制图文是否可见（true=显示，false=覆盖）

    // 初始化状态：索引0、2（第1、3个容器）显示图文，其余（2、4）覆盖图文
    // 注意：JS中索引从0开始，所以第1个是index=0，第2个index=1，第3个index=2，第4个index=3
    if (index === 0 || index === 2) {
      isVisible = true;
      container.classList.add('active'); // active类表示显示图文
    } else {
      isVisible = false;
      container.classList.remove('active'); // 移除active表示覆盖图文
    }

    // 切换函数：控制容器的active类
    const toggleCover = () => {
      isVisible = !isVisible;
      container.classList.toggle('active', isVisible);
    };

    // 统一延迟3秒后启动6秒循环（所有容器同步开始循环）
    setTimeout(() => {
      setInterval(toggleCover, 6000);
    }, 3000);
  });
}

// 页面加载+窗口大小变化执行
document.addEventListener('DOMContentLoaded', initCoverImages);
window.addEventListener('resize', initCoverImages);
                   // 复制功能
            function copyText(element, text, event) {
                event.preventDefault();
                navigator.clipboard.writeText(text).then(() => {
                    const originalText = element.textContent;
                    element.textContent = 'Copied!';
                    setTimeout(() => {
                        element.textContent = originalText;
                    }, 3000);
                });
            }
            
            window.copyText = copyText;
            
            // 初始化覆盖图片功能
            initCoverImages();
        });
            